(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-storage-wager.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-storage-wager.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect;
const _jotai = jotai,
  useSetAtom = _jotai.useSetAtom,
  useAtomValue = _jotai.useAtomValue;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.jotai.atoms,
  pinLocationTypeAtom = _svs$lyckoplatsen$com.pinLocationTypeAtom,
  locationConfirmedAtom = _svs$lyckoplatsen$com.locationConfirmedAtom,
  lyckoplatsenNameAtom = _svs$lyckoplatsen$com.lyckoplatsenNameAtom,
  pinLocationAtom = _svs$lyckoplatsen$com.pinLocationAtom;
const _svs$lyckoplatsen$sha = svs.lyckoplatsen.shared_charity.jotai.atoms,
  activeCharitiesAtom = _svs$lyckoplatsen$sha.activeCharitiesAtom,
  charityAtom = _svs$lyckoplatsen$sha.charityAtom;

function useStorageWager() {
  const setLocationType = useSetAtom(pinLocationTypeAtom);
  const setLocationConfirmed = useSetAtom(locationConfirmedAtom);
  const setLyckoplatsenName = useSetAtom(lyckoplatsenNameAtom);
  const activeCharities = useAtomValue(activeCharitiesAtom);
  const setCharity = useSetAtom(charityAtom);
  const setPinLocation = useSetAtom(pinLocationAtom);
  useEffect(() => {
    var _svs$components$Stora, _svs$components$Stora2;
    const _ref = (_svs$components$Stora = (_svs$components$Stora2 = svs.components.Storage.browser.get('start', 'subscription')) === null || _svs$components$Stora2 === void 0 ? void 0 : _svs$components$Stora2.entry) !== null && _svs$components$Stora !== void 0 ? _svs$components$Stora : {},
      wagers = _ref.wagers;
    if (Array.isArray(wagers) && wagers.length) {
      const _wagers$0$bets$0$geoB = wagers[0].bets[0].geoBoardData,
        geoLoc = _wagers$0$bets$0$geoB.geoLoc,
        geoLocName = _wagers$0$bets$0$geoB.geoLocName,
        geoLocType = _wagers$0$bets$0$geoB.geoLocType,
        charityId = _wagers$0$bets$0$geoB.charityId;
      const lat = Number(parseFloat(geoLoc.latitude.replace(',', '.')).toFixed(6));
      const lng = Number(parseFloat(geoLoc.longitude.replace(',', '.')).toFixed(6));
      if (charityId) {
        const activeCharity = activeCharities.find(activeCharity => activeCharity.charityId === charityId);
        setCharity(activeCharity);
      }
      setPinLocation({
        lat,
        lng
      });
      setLocationConfirmed(true);
      setLocationType(geoLocType);
      setLyckoplatsenName(geoLocName);
      svs.components.Storage.browser.remove('start', 'subscription');
    }
  }, []);
}
setGlobal('svs.lyckoplatsen.page_play.utils.useStorageWager', useStorageWager);

 })(window);